import React, { FC } from 'react'

import type {
  ProductAggregations,
  ProductAggregationsKey,
  UseProducts,
} from '../../../../lib/products'
import Filter from './Filter'

export interface FiltersProps {
  aggregations: ProductAggregations | null | undefined
  listing: UseProducts['listing']
}

const FilterIfPresent: FC<FiltersProps & { id: ProductAggregationsKey }> = ({
  aggregations,
  id,
  listing,
}) => {
  const aggregation = aggregations?.[id]
  return aggregation ? <Filter id={id} aggregation={aggregation} listing={listing} /> : null
}

const Filters: FC<FiltersProps> = ({ aggregations, listing }) => (
  <>
    <FilterIfPresent aggregations={aggregations} listing={listing} id="category" />
    <FilterIfPresent aggregations={aggregations} listing={listing} id="ingredient" />
    <FilterIfPresent aggregations={aggregations} listing={listing} id="ailment" />
    <FilterIfPresent aggregations={aggregations} listing={listing} id="labelStatus" />
    <FilterIfPresent aggregations={aggregations} listing={listing} id="nameRange" />
    <FilterIfPresent aggregations={aggregations} listing={listing} id="productForm" />
  </>
)

export default Filters
